import React, { useState } from "react";
import { ref, update } from "firebase/database";
import { db } from "../services/firebase";
import "./EditProfile.css";

function EditProfile({ user, profile, onDone }) {
  const [name, setName] = useState(profile.name || "");
  const [username, setUsername] = useState(profile.username || "");
  const [educationLevel, setEducationLevel] = useState(profile.educationLevel || "");
  const [course, setCourse] = useState(profile.course || "");
  const [institute, setInstitute] = useState(profile.institute || "");
  const [avatar, setAvatar] = useState(profile.avatar || "");
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    try {
      const userRef = ref(db, "users/" + user.uid);
      await update(userRef, {
        name,
        username,
        avatar,
        educationLevel,
        course,
        institute,
      });
      alert("✅ Profile updated!");
      onDone();
    } catch (err) {
      alert("❌ Failed to update profile: " + err.message);
    }
    setLoading(false);
  };

  return (
    <div className="dashboard-content">
      <h2>✏️ Edit Profile</h2>

      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        {avatar ? (
          <img
            src={avatar}
            alt="Avatar Preview"
            style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover" }}
          />
        ) : (
          <div
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              background: "#ccc",
              lineHeight: "100px",
              fontSize: "2rem",
              margin: "auto",
              color: "#fff",
            }}
          >
            {name[0] || "U"}
          </div>
        )}
      </div>

      <label>🖼️ Avatar Image URL</label>
      <input
        type="text"
        value={avatar}
        onChange={(e) => setAvatar(e.target.value)}
        placeholder="Paste image link (optional)"
      />

      <br/>

      <label>Name</label>
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <label>Username</label>
      <input
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <label>Email (non-editable)</label>
      <input type="email" value={user.email} disabled />

      <label>🎓 Education Level</label>
      <select value={educationLevel} onChange={(e) => setEducationLevel(e.target.value)}>
        <option value="">Select Level</option>
        <option value="Undergraduate">Undergraduate</option>
        <option value="Graduate">Graduate</option>
        <option value="Postgraduate">Postgraduate</option>
        <option value="Other">Other</option>
      </select>

      <label>🎯 Course (e.g. B.Tech, B.E)</label>
      <input
        type="text"
        value={course}
        onChange={(e) => setCourse(e.target.value)}
        placeholder="B.Tech / B.E / BCA etc."
      />

      <label>🏫 Current Institute</label>
      <input
        type="text"
        value={institute}
        onChange={(e) => setInstitute(e.target.value)}
        placeholder="School / College Name"
      />

      <div style={{ marginTop: "20px" }}>
        <button onClick={handleSave} disabled={loading}>
          💾 {loading ? "Saving..." : "Save Changes"}
        </button>
        <button onClick={onDone} style={{ marginLeft: "10px" }}>
          ❌ Cancel
        </button>
      </div>
    </div>
  );
}

export default EditProfile;
